import { isElementInsideRoom } from "../isElementInsideRoom";
import { MIN_POLYGON_POINTS } from "../../polygonPointMutators";
import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";
import type { FloorPlanRoom } from "../../types";
import type { ScopeElementsToRooms } from "./types";

const isInsideAnyRoom = (
  element: GroupedSmartSurveyorElement,
  rooms: FloorPlanRoom[],
): boolean => rooms.some((room) => isElementInsideRoom({ element, room }));

export const scopeElementsToRooms: ScopeElementsToRooms = ({
  groupIds,
  byGroupId,
  rooms,
}) => {
  const drawableRooms = rooms.filter(
    (room) => room.points.length >= MIN_POLYGON_POINTS,
  );
  if (drawableRooms.length === 0) return { groupIds, byGroupId };

  const scopedGroupIds: string[] = [];
  const scopedByGroupId: Record<string, GroupedSmartSurveyorElement[]> = {};
  for (const groupId of groupIds) {
    const elements = (byGroupId[groupId] ?? []).filter((element) =>
      isInsideAnyRoom(element, drawableRooms),
    );
    if (elements.length === 0) continue;
    scopedGroupIds.push(groupId);
    scopedByGroupId[groupId] = elements;
  }
  return { groupIds: scopedGroupIds, byGroupId: scopedByGroupId };
};
